import { render, staticRenderFns } from "./Enroll.vue?vue&type=template&id=1197a1d0&"
import script from "./Enroll.vue?vue&type=script&lang=ts&"
export * from "./Enroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports